<template>
  <el-dialog
    :title="type === 'edit'?'编辑':'新增'"
    :visible.sync="dialog"
    :width="getIsMobile?'100%':'50%'"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
  >
    <el-form ref="formRef" :model="form" label-width="80px" :label-position="getIsMobile?'top':'right'" :rules="rules"
             class="custom-form">
      <el-form-item label="币种" prop="currency">
        <el-input v-model="form.currency" placeholder="请输入币种"></el-input>
      </el-form-item>
      <el-form-item label="汇率" prop="rate">
        <el-input v-model="form.rate" placeholder="请输入汇率"></el-input>
      </el-form-item>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleReset">重 置</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {defineComponent, reactive, ref} from '@vue/composition-api'
import useRootSetting from '@/hooks/useRootSetting';

export default defineComponent({
  components: {},
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    formData: {
      type: Object,
      default: () => {
      }
    },
    submitLoading: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {emit}) {

    const {getIsMobile} = useRootSetting()
    const formRef = ref(null)

    const rules = {
      currency: [
        {required: true, message: '币种不能为空', trigger: 'blur'}
      ],
      // rate: [
      //   {required: true, message: '汇率不能为空', trigger: 'blur'}
      // ]
    }

    const defaultForm = () => ({
      currency: '',
      rate: ''
    })
    const form = reactive(defaultForm())


    const handleReset = () => {
      Object.assign(form, defaultForm())
    }
    const handleSubmit = () => {
      formRef.value.validate(valid => {
        if (valid) {
          emit('submit', form)
        }
      })
    }
    const handleClose = () => {
      Object.assign(form, defaultForm())
      emit('close')
    }

    return {
      getIsMobile,
      formRef,
      form,
      rules,
      handleReset,
      handleSubmit,
      handleClose
    }
  }
})
</script>
<style scoped>
.custom-form {
  max-height: 600px;
  overflow-y: scroll;
}
</style>
